import React from 'react';
import styles from './BlogMenu.scss';
import {__t} from '../../common/lang/text-resource';


export default function BlogMenu() {

	return (
		<ul className={styles.container}>
			<li>
				<a href={__t("https://blog.superhosting.bg/")} title={__t("Начало")}>{__t('Начало')}</a>
			</li>
			<li>
				<a href={__t('https-blog-superhosting-bg-category-superhosting-93fa18')}
				   title={__t("Електронна търговия")}>
					{__t('Електронна търговия')}
				</a>
			</li>
			<li>
				<a href={__t('https-blog-superhosting-bg-category-superhosting-0857ef')} title={__t("За вашия уебсайт")}>
					{__t('За вашия уебсайт')}
				</a>
			</li>
			<li>
				<a href={__t('https-blog-superhosting-bg-category-superhosting-1ba2df')} title={__t("Нашите клиенти")}>
					{__t('Нашите клиенти')}
				</a>
			</li>
			<li>
				<a href={__t("https://blog.superhosting.bg/category/superhosting-news")} title={__t("Новини и събития")}>
					{__t('Новини и събития')}
				</a>
			</li>
			<li>
				<a
					href={__t('https-blog-superhosting-bg-category-superhosting-1abda6')}
					title={__t("Съвети от support-a")}>
					{__t('Съвети от support-a')}
				</a>
			</li>
			<li>
				<a
					href={__t('https-blog-superhosting-bg-category-superhosting-050796')}
					title={__t("Технологии")}>
					{__t('Технологии')}
				</a>
			</li>
		</ul>
	);
}